import React, { useEffect, useState } from 'react';
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormInput,
  CBadge
} from '@coreui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { insert, update, remove } from 'src/services/CashAndBanks';
import CIcon from '@coreui/icons-react';
import { cilTrash } from '@coreui/icons';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';

function CABActions() {
  const [id, setID] = useState(0);
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [bankName, setBankName] = useState('');
  const [description, setDescription] = useState('');
  const [initialBalance, setInitialBalance] = useState(0);
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState("")
  const [color, setColor] = useState("")

  useEffect(() => {
    if (location.state) {
      setID(location.state.id);
      setName(location?.state?.name ?? '');
      setCode(location?.state?.code ?? '');
      setBankName(location?.state?.bankName ?? '');
      setDescription(location?.state?.description ?? '');
    }
  }, [location]);
  async function deleteCab() {
    await remove(id).then((response) => {
      if ((response?.data?.success ?? 0) == 1) {
        setMessage(response?.data?.message)
        setOpen(true)
        const data = () =>
        setTimeout(() => {
          navigate(-1);
        }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(response?.data?.message)
        setOpen(true)
        setColor("red")
      }
    });
  }
  async function handleSubmit(e) {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() === false) {
    } else {
      let data = {
        id: id,
        name: name,
        code: code,
        bankName: bankName,
        description: description,
        initialBalance: initialBalance
      };
      if (location.state) {
        await update(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message)
            setOpen(true)
            const data = () =>
            setTimeout(() => {
              navigate(-1);
            }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message)
            setOpen(true)
            setColor("red")
          }
        });
      } else {
        await insert(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message)
            setOpen(true)
            const data = () =>
            setTimeout(() => {
              navigate(-1);
            }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message ?? ls.get("errorMessage"))
            setOpen(true)
            setColor("red")
          }
        });
      }
    }
    setValidated(true);

    // e.preventDefault()
    // console.log('bener')
  }
  return (
    <CCard>
      <Toaster
        open={open}
        message={message}
        setOpen={setOpen}
        ahd={1500}
        color={color ?? "red"}
      />
      <CCardHeader>Actions - Cash and Banks</CCardHeader>
      <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Name</CFormLabel>&nbsp;
              <CBadge color="warning">Required</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Code</CFormLabel>&nbsp;
              <CBadge color="warning">Required</CBadge>
            </CCol>
            <CCol>
              <CFormInput type="text" value={code} maxLength={50} onChange={(e) => setCode(e.target.value)} required />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Bank Name</CFormLabel>&nbsp;
              <CBadge color="warning">Required</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="text"
                value={bankName}
                maxLength={50}
                onChange={(e) => setBankName(e.target.value)}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Description</CFormLabel>
            </CCol>
            <CCol>
              <CFormInput type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>{location.state ? '' : 'Initial'} Balance</CFormLabel>
            </CCol>
            <CCol>
              <CFormInput
                type="number"
                value={initialBalance}
                disabled={location.state ? true : false}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setInitialBalance(e.target.value)}
              />
            </CCol>
          </CRow>
        </div>
        <CCardFooter style={{ textAlign: 'right' }}>
          {location.state ? (
            <CButton
              color="danger"
              onClick={() => {
                deleteCab();
              }}
            >
              <CIcon icon={cilTrash} />
            </CButton>
          ) : (
            <div></div>
          )}
          &emsp;
          <CButton
            style={{
              color: 'black',
              backgroundColor: 'white'
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </CButton>
          &emsp;
          <CButton
            color="success"
            style={{
              color: 'white'
            }}
            type="submit"
          >
            Save
          </CButton>
        </CCardFooter>
      </CForm>
    </CCard>
  );
}

export default CABActions;
